import React from 'react';
import { LockIcon, MailCheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-20 sm:py-24" data-id="element-98" data-mp="vhahy8me66yp">
      <div className="mx-auto max-w-2xl text-center" data-id="element-99" data-mp="19g0bjea05oib">
        <h2 className="font-display text-[1.85rem] font-black leading-tight tracking-tight text-white sm:text-[2.6rem]" data-id="element-100" data-mp="15ddgl4i1bngw">
          Pronto a portare la musica in{' '}
          <span className="italic text-tangerine" data-id="element-101" data-mp="1jbaga9rsc9zs">ogni classe?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-102" data-mp="1ed8x7oud0aob">
          Smetti di pianificare. Inizia a insegnare. Ottieni risultati.
        </p>
        <div className="mt-8" data-id="element-103" data-mp="1o3lhdfy9i1tx">
          <CtaButton label="Voglio Musica Pronta ora" data-id="element-104" data-mp="1o4dc6ok1bvj5" />
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] font-semibold text-white/55" data-id="element-105" data-mp="222usw2biw7rk">
          <li className="flex items-center gap-1.5" data-id="element-106" data-mp="1x64edjfd9k89">
            <LockIcon className="h-3.5 w-3.5 text-tangerine" aria-hidden="true" data-id="element-107" data-mp="n649jisb5ija" />
            Pagamento sicuro SSL
          </li>
          <li className="flex items-center gap-1.5" data-id="element-108" data-mp="s5gyc92qozoi">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-tangerine" aria-hidden="true" data-id="element-109" data-mp="x3sa4pclhk9d" />
            7 giorni di garanzia
          </li>
          <li className="flex items-center gap-1.5" data-id="element-110" data-mp="120sdutlz2axb">
            <MailCheckIcon className="h-3.5 w-3.5 text-tangerine" aria-hidden="true" data-id="element-111" data-mp="163f9z6poei0b" />
            Consegna immediata via email
          </li>
        </ul>
      </div>
    </section>;
}